import { newList as list } from "@/pages/voice/data";
import art1 from "./artDetail/art1";
import art2 from "./artDetail/art2";
import art3 from "./artDetail/art3";
import art4 from "./artDetail/art4";
import art5 from "./artDetail/art5";
import art6 from "./artDetail/art6";
import art7 from "./artDetail/art7";
import art8 from "./artDetail/art8";
import art9 from "./artDetail/art9";
import art10 from "./artDetail/art10";
import art11 from "./artDetail/art11";
import art12 from "./artDetail/art12";
import art13 from "./artDetail/art13";
import art14 from "./artDetail/art14";
import art15 from "./artDetail/art15";
import art16 from "./artDetail/art16";
import art17 from "./artDetail/art17";
import art18 from "./artDetail/art18";
import art19 from "./artDetail/art19";
import art20 from "./artDetail/art20";

export const newList: NewDetail[] = [
  {
    ...list[0],
    detail: art18,
  },
  {
    ...list[1],
    detail: art19,
  },
  {
    ...list[2],
    detail: art20,
  },
  {
    ...list[3],
    detail: art1,
  },
  {
    ...list[4],
    detail: art2,
  },
  {
    ...list[5],
    detail: art3,
  },
  {
    ...list[6],
    detail: art4,
  },
  {
    ...list[7],
    detail: art5,
  },
  {
    ...list[8],
    detail: art6,
  },
  {
    ...list[9],
    detail: art7,
  },
  {
    ...list[10],
    detail: art8,
  },
  {
    ...list[11],
    detail: art9,
  },
  {
    ...list[12],
    detail: art10,
  },
  {
    ...list[13],
    detail: art11,
  },
  {
    ...list[14],
    detail: art12,
  },
  {
    ...list[15],
    detail: art13,
  },
  {
    ...list[16],
    detail: art14,
  },
  {
    ...list[17],
    detail: art15,
  },
  {
    ...list[18],
    detail: art16,
  },
  {
    ...list[19],
    detail: art17,
  },
];
